import i18n from 'i18next';

const TypeTest = ({testType}) => {
    switch (testType) {
        case 1 :
            return i18n.t('test_type').toUpperCase();
        case 2 :
            return i18n.t('practice_type').toUpperCase();
        case 3:
            return i18n.t('exam_type').toUpperCase();
        case 4:
            return i18n.t('multiple_choice').toUpperCase();
        case 5:
            return i18n.t('voted').toUpperCase();
        case 6:
            return i18n.t('survey').toUpperCase();
        case 7:
            return i18n.t('multiple_choice_comparison').toUpperCase();
        case 8:
            return i18n.t('multiple_choice_script').toUpperCase();
        case 9:
            return i18n.t('multiple_choice_test').toUpperCase();
        default:
            return "";
    }
};

export default TypeTest;